document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.quantityButton === 'plus' ? 1 : -1;
        const min = Number(input.min || 1);
        input.value = Math.max(min, Number(input.value || min) + direction);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product gallery: thumbnails, keyboard controls and horizontal swipes share one state.
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryInitialized === 'true') return;
    const featured = gallery.querySelector('[data-featured-image]');
    const surface = gallery.querySelector('[data-gallery-surface]') || gallery.querySelector('.product-gallery__featured');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const status = gallery.querySelector('[data-gallery-status]');
    const zoom = gallery.querySelector('[data-gallery-zoom]');
    const hint = gallery.querySelector('[data-gallery-hint]');
    const nutritionPanel = gallery.querySelector('[data-gallery-nutrition-panel]');
    if (!featured || !surface || !thumbnails.length || thumbnails.some((thumbnail) => !thumbnail.dataset.imageSrc)) return;

    let current = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
    let gesture = null;
    const multipleImages = thumbnails.length > 1;
    const usesNutritionPanel = (thumbnail) => Boolean(nutritionPanel && thumbnail.dataset.galleryPanel === 'nutrition');

    const updateControls = () => {
      const thumbnail = thumbnails[current];
      const isNutrition = thumbnail.dataset.imageLabel === 'true';
      const isNutritionPanel = usesNutritionPanel(thumbnail);
      thumbnails.forEach((item, index) => {
        item.classList.toggle('is-active', index === current);
        item.setAttribute('aria-pressed', String(index === current));
      });
      surface.classList.toggle('is-nutrition-image', isNutrition);
      surface.classList.toggle('is-nutrition-panel', isNutritionPanel);
      featured.hidden = isNutritionPanel;
      if (nutritionPanel) nutritionPanel.hidden = !isNutritionPanel;
      if (status) status.textContent = `Image ${current + 1} of ${thumbnails.length}${isNutrition ? ' — Nutrition information' : ''}`;
      if (zoom) {
        zoom.href = thumbnail.dataset.imageSrc;
        zoom.textContent = isNutritionPanel ? 'View original packaging label ↗' : 'Enlarge image ↗';
        zoom.setAttribute('aria-label', isNutritionPanel ? 'Open original packaging label at full size' : isNutrition ? 'Open nutrition information at full size' : 'Open product image at full size');
      }
      if (hint) hint.textContent = thumbnails[(current + 1) % thumbnails.length]?.dataset.imageLabel === 'true' && !isNutrition ? 'Swipe left for nutrition information' : 'Swipe to browse images';
      if (previous) previous.hidden = !multipleImages;
      if (next) next.hidden = !multipleImages;
    };

    const showImage = (index) => {
      const normalized = ((index % thumbnails.length) + thumbnails.length) % thumbnails.length;
      if (normalized === current) return;
      current = normalized;
      const thumbnail = thumbnails[current];
      if (!usesNutritionPanel(thumbnail)) {
        featured.removeAttribute('srcset');
        featured.removeAttribute('sizes');
        featured.src = thumbnail.dataset.imageSrc;
        featured.alt = thumbnail.dataset.imageAlt || '';
      }
      updateControls();
    };

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => showImage(index));
    });
    previous?.addEventListener('click', () => showImage(current - 1));
    next?.addEventListener('click', () => showImage(current + 1));

    gallery.addEventListener('keydown', (event) => {
      if (!multipleImages || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) return;
      const destinations = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: thumbnails.length - 1 };
      if (!Object.prototype.hasOwnProperty.call(destinations, event.key)) return;
      event.preventDefault();
      showImage(destinations[event.key]);
    });

    const clearGesture = () => {
      const pointerId = gesture?.pointerId;
      gesture = null;
      if (pointerId !== undefined && surface.hasPointerCapture?.(pointerId)) surface.releasePointerCapture(pointerId);
    };
    surface.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary) { clearGesture(); return; }
      if (!multipleImages || event.button !== 0 || event.target.closest('button, a, input, textarea, select')) return;
      gesture = { pointerId: event.pointerId, x: event.clientX, y: event.clientY };
      // Capture mouse drags that finish just outside the image, without preventing native scrolling.
      try { surface.setPointerCapture(event.pointerId); } catch (_) { /* Capture is optional. */ }
    });
    surface.addEventListener('pointerup', (event) => {
      if (!gesture || gesture.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - gesture.x;
      const deltaY = event.clientY - gesture.y;
      clearGesture();
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;
      showImage(current + (deltaX < 0 ? 1 : -1));
    });
    surface.addEventListener('pointercancel', (event) => {
      if (gesture?.pointerId === event.pointerId) clearGesture();
    });
    surface.addEventListener('lostpointercapture', (event) => {
      if (gesture?.pointerId === event.pointerId) gesture = null;
    });

    updateControls(); // Keep the server-rendered initial src/srcset/sizes untouched.
    gallery.dataset.galleryInitialized = 'true';
  });

  const offerPopup = document.querySelector('[data-offer-popup]');
  if (offerPopup && !document.querySelector('[data-hydro-funnel]')) {
    const dismissKey = '59-offer-popup-dismissed-at';
    const submittedKey = '59-offer-popup-submitted';
    const oneWeek = 7 * 24 * 60 * 60 * 1000;
    const hasSuccess = Boolean(offerPopup.querySelector('[data-offer-success]'));
    const hasError = Boolean(offerPopup.querySelector('[data-offer-error]'));
    const dismissedAt = Number(window.localStorage?.getItem(dismissKey) || 0);
    const alreadySubmitted = window.localStorage?.getItem(submittedKey) === 'true';
    const forcePreview = new URLSearchParams(window.location.search).has('offer_preview');
    let previousFocus = null;

    const openOfferPopup = () => {
      previousFocus = document.activeElement;
      offerPopup.hidden = false;
      document.documentElement.classList.add('ref-offer-is-open');
      window.setTimeout(() => {
        const firstInput = offerPopup.querySelector('input:not([type="hidden"])');
        const closeButton = offerPopup.querySelector('.ref-offer-popup__close');
        (hasSuccess ? closeButton : firstInput || closeButton)?.focus?.();
      }, 40);
    };

    const closeOfferPopup = () => {
      offerPopup.hidden = true;
      document.documentElement.classList.remove('ref-offer-is-open');
      window.localStorage?.setItem(dismissKey, String(Date.now()));
      previousFocus?.focus?.();
    };

    offerPopup.querySelectorAll('[data-offer-dismiss]').forEach((button) => {
      button.addEventListener('click', closeOfferPopup);
    });

    offerPopup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeOfferPopup();
    });

    offerPopup.querySelector('form')?.addEventListener('submit', () => {
      window.localStorage?.setItem(dismissKey, String(Date.now()));
    });

    if (hasSuccess) {
      window.localStorage?.setItem(submittedKey, 'true');
      openOfferPopup();
    } else if (hasError) {
      openOfferPopup();
    } else if (forcePreview || (!alreadySubmitted && (!dismissedAt || Date.now() - dismissedAt > oneWeek))) {
      window.setTimeout(openOfferPopup, 900);
    }
  }
});

/* 59 cart drawer. One global controller keeps Shopify cart state, focus, and totals in sync. */
(() => {
  if (window.__refCartDrawerInitialized) return;
  window.__refCartDrawerInitialized = true;

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.ref-cart-drawer__panel');
  const closeButton = drawer.querySelector('.ref-cart-drawer__close');
  const countLabel = drawer.querySelector('[data-cart-drawer-count]');
  const itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  const emptyState = drawer.querySelector('[data-cart-drawer-empty]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const subtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
  const status = drawer.querySelector('[data-cart-drawer-status]');
  const shipping = drawer.querySelector('.ref-cart-drawer__shipping');
  const shippingMessage = drawer.querySelector('[data-cart-drawer-shipping-message]');
  const shippingTrack = drawer.querySelector('[data-cart-drawer-shipping-track]');
  const shippingFill = drawer.querySelector('[data-cart-drawer-shipping-fill]');
  const threshold = Number(drawer.dataset.freeShippingThreshold || 150000);
  const hydroProductId = Number(drawer.dataset.hydroProductId || 0);
  const hydroOfferTitle = drawer.dataset.hydroOfferTitle || 'Hydro+ Buy 2, Get 1 Free';
  const cartPath = new URL(drawer.dataset.cartUrl || '/cart', window.location.origin).pathname.replace(/\/$/, '') || '/cart';
  let cartState = null;
  let lastFocus = null;
  let closeTimer = null;
  let statusTimer = null;
  let shippingProgress = null;
  let shippingFrame = null;
  let shippingCelebrationTimer = null;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const endpoint = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}${path}`;
  };

  const formatWithDelimiters = (value, precision = 2, thousands = ',', decimal = '.') => {
    const number = Number(value || 0) / 100;
    const parts = number.toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
  };

  const formatMoney = (cents) => {
    const format = drawer.dataset.moneyFormat || 'R {{amount}}';
    const token = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
    const formats = {
      amount: () => formatWithDelimiters(cents, 2, ',', '.'),
      amount_no_decimals: () => formatWithDelimiters(cents, 0, ',', '.'),
      amount_with_comma_separator: () => formatWithDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => formatWithDelimiters(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => formatWithDelimiters(cents, 2, "'", '.'),
      amount_no_decimals_with_space_separator: () => formatWithDelimiters(cents, 0, ' ', '.'),
      amount_with_space_separator: () => formatWithDelimiters(cents, 2, ' ', ','),
    };
    return format.replace(/\{\{\s*\w+\s*\}\}/, (formats[token] || formats.amount)());
  };

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  const setStatus = (message = '', isError = false) => {
    window.clearTimeout(statusTimer);
    status.textContent = message;
    status.classList.toggle('is-error', isError);
    status.setAttribute('role', isError ? 'alert' : 'status');
    if (message && !isError) {
      statusTimer = window.setTimeout(() => {
        status.textContent = '';
      }, 1600);
    }
  };

  const updateHeaderCount = (cart) => {
    const count = Number(cart?.item_count || 0);
    document.querySelectorAll('[data-cart-drawer-trigger]').forEach((link) => {
      const sharedBadge = link.querySelector('[data-bag-count]');
      if (sharedBadge) {
        sharedBadge.textContent = count > 99 ? '99+' : String(count);
        link.querySelector('.ref-header__cart-count')?.remove();
        link.setAttribute('aria-label', count > 0 ? `Cart, ${count} ${count === 1 ? 'item' : 'items'}` : 'Cart');
        return;
      }
      let badge = link.querySelector('.ref-header__cart-count');
      if (count > 0 && !badge) {
        badge = createElement('span', 'ref-header__cart-count');
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      if (badge) {
        if (count > 0) badge.textContent = count > 99 ? '99+' : String(count);
        else badge.remove();
      }
      link.setAttribute('aria-label', count > 0 ? `Cart, ${count} ${count === 1 ? 'item' : 'items'}` : 'Cart');
    });
  };

  const renderShipping = (total) => {
    const remaining = Math.max(0, threshold - Number(total || 0));
    const progress = Math.min(100, Math.max(0, threshold ? Number(total || 0) / threshold * 100 : 0));
    const previousProgress = shippingProgress;
    const progressChanged = previousProgress === null || Math.abs(previousProgress - progress) > 0.01;
    const unlockedNow = previousProgress !== null && previousProgress < 100 && progress >= 100;
    shippingProgress = progress;
    shipping.classList.toggle('is-complete', remaining === 0);
    shippingMessage.replaceChildren();
    if (remaining === 0) {
      shippingMessage.textContent = 'You have unlocked free shipping.';
      shippingTrack.setAttribute('aria-valuetext', 'Free shipping unlocked');
    } else {
      shippingMessage.append('Add ');
      shippingMessage.append(createElement('strong', '', formatMoney(remaining)));
      shippingMessage.append(' more to unlock free shipping.');
      shippingTrack.setAttribute('aria-valuetext', `${formatMoney(remaining)} remaining`);
    }
    shippingTrack.setAttribute('aria-valuenow', String(Math.round(progress)));
    if (progressChanged) {
      window.cancelAnimationFrame(shippingFrame);
      const updateFill = () => {
        shippingFill.style.setProperty('--ref-cart-drawer-shipping-progress', String(progress / 100));
        shippingFrame = null;
      };
      if (reducedMotion.matches) updateFill();
      else shippingFrame = window.requestAnimationFrame(updateFill);
    }
    if (unlockedNow && !reducedMotion.matches) {
      window.clearTimeout(shippingCelebrationTimer);
      shipping.classList.remove('is-celebrating');
      window.requestAnimationFrame(() => shipping.classList.add('is-celebrating'));
      shippingCelebrationTimer = window.setTimeout(() => shipping.classList.remove('is-celebrating'), 760);
    } else if (progress < 100) {
      window.clearTimeout(shippingCelebrationTimer);
      shipping.classList.remove('is-celebrating');
    }
  };

  const buildItem = (item, hydroOffer = null) => {
    const row = createElement('article', 'ref-cart-drawer-item');
    row.dataset.cartDrawerItem = item.key;

    const media = createElement('a', 'ref-cart-drawer-item__media');
    media.href = item.url;
    if (item.image) {
      const image = document.createElement('img');
      const imageUrl = new URL(item.image, window.location.origin);
      imageUrl.searchParams.set('width', '220');
      image.src = imageUrl.href;
      image.alt = item.product_title || item.title || '';
      image.width = 110;
      image.height = 110;
      image.loading = 'lazy';
      media.appendChild(image);
    } else {
      media.appendChild(createElement('span', '', '59'));
    }

    const details = createElement('div', 'ref-cart-drawer-item__details');
    const top = createElement('div', 'ref-cart-drawer-item__top');
    const identity = createElement('div');
    identity.appendChild(createElement('p', 'ref-cart-drawer-item__vendor', item.vendor || '59 Nutrition'));
    const title = createElement('h3');
    const titleLink = createElement('a', '', item.product_title || item.title);
    titleLink.href = item.url;
    title.appendChild(titleLink);
    identity.appendChild(title);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      identity.appendChild(createElement('small', 'ref-cart-drawer-item__variant', item.variant_title));
    }
    const price = createElement('div', 'ref-cart-drawer-item__price-wrap');
    if (Number(item.original_line_price || 0) > Number(item.final_line_price || 0)) {
      price.appendChild(createElement('del', '', formatMoney(item.original_line_price)));
    }
    price.appendChild(createElement('strong', 'ref-cart-drawer-item__price', formatMoney(item.final_line_price)));
    const allocations = Array.isArray(item.line_level_discount_allocations)
      ? item.line_level_discount_allocations
      : [];
    allocations.filter((allocation) => Number(allocation?.amount || 0) > 0).forEach((allocation) => {
      const label = allocation?.discount_application?.title || 'Automatic discount';
      price.appendChild(createElement('small', '', `${label} · -${formatMoney(allocation.amount)}`));
    });
    top.append(identity, price);

    const controls = createElement('div', 'ref-cart-drawer-item__controls');
    const quantity = createElement('div', 'ref-cart-drawer-item__quantity');
    const minus = createElement('button', '', '−');
    minus.type = 'button';
    minus.dataset.cartDrawerQuantity = 'minus';
    minus.setAttribute('aria-label', `Decrease quantity for ${item.product_title}`);
    const input = document.createElement('input');
    input.type = 'number';
    input.min = '0';
    input.value = String(item.quantity);
    input.inputMode = 'numeric';
    input.dataset.cartDrawerQuantityInput = item.key;
    input.setAttribute('aria-label', `Quantity for ${item.product_title}`);
    const plus = createElement('button', '', '+');
    plus.type = 'button';
    plus.dataset.cartDrawerQuantity = 'plus';
    plus.setAttribute('aria-label', `Increase quantity for ${item.product_title}`);
    quantity.append(minus, input, plus);
    const remove = createElement('button', 'ref-cart-drawer-item__remove', 'Remove');
    remove.type = 'button';
    remove.dataset.cartDrawerRemove = item.key;
    remove.setAttribute('aria-label', `Remove ${item.product_title} from cart`);
    controls.append(quantity, remove);
    details.append(top, controls);

    if (hydroOffer) {
      const offer = createElement('p', 'ref-cart-drawer-item__offer');
      if (hydroOffer.savings > 0) {
        offer.classList.add('is-applied');
        offer.appendChild(createElement('strong', '', `3-for-2 applied. You saved ${formatMoney(hydroOffer.savings)}.`));
      }
      if (hydroOffer.remaining > 0) {
        offer.append(`${hydroOffer.savings > 0 ? ' ' : ''}Add ${hydroOffer.remaining} more ${hydroOffer.remaining === 1 ? 'box' : 'boxes'} for another free Hydro+.`);
      } else if (hydroOffer.savings === 0) {
        offer.textContent = 'Your free Hydro+ applies automatically.';
      }
      details.appendChild(offer);
    }
    row.append(media, details);
    return row;
  };

  const renderCart = (cart) => {
    cartState = cart;
    const rawItems = Array.isArray(cart?.items) ? cart.items : [];
    const items = rawItems.filter((item) => Number(item?.quantity || 0) > 0);
    const normalizedTotal = items.reduce(
      (total, item) => total + Number(item?.final_line_price || 0),
      0
    );
    const hydroItems = items.filter((item) => Number(item?.product_id || 0) === hydroProductId);
    const hydroUnits = hydroItems.reduce((total, item) => total + Number(item?.quantity || 0), 0);
    const hydroSavings = hydroItems.reduce((total, item) => {
      const allocations = Array.isArray(item?.line_level_discount_allocations)
        ? item.line_level_discount_allocations
        : [];
      return total + allocations
        .filter((allocation) => allocation?.discount_application?.title === hydroOfferTitle)
        .reduce((sum, allocation) => sum + Number(allocation?.amount || 0), 0);
    }, 0);
    const hydroRemainder = hydroUnits % 3;
    const hydroOffer = hydroUnits > 0 ? {
      savings: hydroSavings,
      remaining: hydroRemainder === 0 ? (hydroSavings > 0 ? 3 : 0) : 3 - hydroRemainder,
    } : null;
    let hydroOfferRendered = false;
    countLabel.textContent = cart?.item_count ? `(${cart.item_count})` : '';
    itemsContainer.replaceChildren(...items.map((item) => {
      const isHydro = Number(item?.product_id || 0) === hydroProductId;
      const itemOffer = isHydro && !hydroOfferRendered ? hydroOffer : null;
      if (isHydro) hydroOfferRendered = true;
      return buildItem(item, itemOffer);
    }));
    emptyState.hidden = items.length > 0;
    footer.hidden = items.length === 0;
    if (items.length > 0) subtotal.textContent = formatMoney(normalizedTotal);
    renderShipping(normalizedTotal);
    updateHeaderCount(cart);
    drawer.setAttribute('aria-busy', 'false');
    setStatus('');
  };

  const fetchCart = async () => {
    drawer.setAttribute('aria-busy', 'true');
    setStatus('Loading your cart...');
    const response = await fetch(endpoint('cart.js'), {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error('Your cart could not be loaded.');
    return response.json();
  };

  const openDrawer = async ({ cart, trigger } = {}) => {
    window.clearTimeout(closeTimer);
    lastFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('ref-cart-drawer-is-open');
    window.requestAnimationFrame(() => drawer.classList.add('is-open'));
    if (cart) renderCart(cart);
    else if (cartState) renderCart(cartState);
    else {
      try {
        renderCart(await fetchCart());
      } catch (error) {
        drawer.setAttribute('aria-busy', 'false');
        setStatus(error.message, true);
      }
    }
    window.setTimeout(() => closeButton.focus(), 220);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ref-cart-drawer-is-open');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      drawer.hidden = true;
      lastFocus?.focus?.();
    }, 280);
  };

  const changeLine = async (key, quantity) => {
    if (!key || drawer.classList.contains('is-updating')) return;
    drawer.classList.add('is-updating');
    drawer.setAttribute('aria-busy', 'true');
    setStatus(quantity === 0 ? 'Removing item...' : 'Updating your cart...');
    try {
      const response = await fetch(endpoint('cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: key, quantity }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || result.message || 'The cart could not be updated.');
      renderCart(result);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: result } }));
      setStatus(quantity === 0 ? 'Item removed.' : 'Cart updated.');
    } catch (error) {
      drawer.setAttribute('aria-busy', 'false');
      if (cartState) renderCart(cartState);
      setStatus(error.message, true);
    } finally {
      drawer.classList.remove('is-updating');
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-drawer-trigger]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if ((window.location.pathname.replace(/\/$/, '') || '/') === cartPath) return;
    event.preventDefault();
    openDrawer({ trigger });
  });

  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    const remove = event.target.closest('[data-cart-drawer-remove]');
    if (remove) {
      changeLine(remove.dataset.cartDrawerRemove, 0);
      return;
    }
    const quantityButton = event.target.closest('[data-cart-drawer-quantity]');
    if (!quantityButton) return;
    const row = quantityButton.closest('[data-cart-drawer-item]');
    const input = row?.querySelector('[data-cart-drawer-quantity-input]');
    if (!row || !input) return;
    const direction = quantityButton.dataset.cartDrawerQuantity === 'plus' ? 1 : -1;
    changeLine(row.dataset.cartDrawerItem, Math.max(0, Number(input.value || 0) + direction));
  });

  drawer.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-drawer-quantity-input]');
    if (!input) return;
    changeLine(input.dataset.cartDrawerQuantityInput, Math.max(0, Number(input.value || 0)));
  });

  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')]
      .filter((element) => !element.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('cart:open', (event) => {
    openDrawer({ cart: event.detail?.cart, trigger: event.detail?.trigger });
  });

  document.addEventListener('cart:updated', (event) => {
    if (!event.detail?.cart) return;
    cartState = event.detail.cart;
    updateHeaderCount(cartState);
    if (!drawer.hidden) renderCart(cartState);
  });
})();
/* End 59 cart drawer. */

/* 59 product-to-cart flight. Delegated so Shopify section reloads need no rebind. */
(() => {
  if (window.__refCartFlyInitialized) return;
  window.__refCartFlyInitialized = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const nativeForms = 'form.product-form, form.ref-product-buy-form';
  const imageSelectors = [
    '[data-featured-image]',
    '.ref-product-main-image',
    '.product-card__media img',
    '[data-product-image] img',
    '[data-product-image]',
    '.product-media img',
    '.product__media img'
  ];
  const replayingForms = new WeakSet();
  const activeForms = new WeakSet();

  const isVisible = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return rect.width > 8 && rect.height > 8 && style.display !== 'none' && style.visibility !== 'hidden';
  };

  const isInViewport = (rect, inset = 8) => (
    rect.bottom > inset
    && rect.right > inset
    && rect.top < window.innerHeight - inset
    && rect.left < window.innerWidth - inset
  );

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const findCart = () => {
    const cart = document.querySelector('.ref-header__cart-link, header a[href$="/cart"], header a[href*="/cart?"]');
    return isVisible(cart) ? cart : null;
  };

  const findProductImage = (button, form) => {
    const scopes = [
      button.closest('.ref-product-feature'),
      button.closest('.product-layout'),
      button.closest('.product-main'),
      button.closest('.product-card'),
      form?.closest('section'),
      form?.parentElement
    ].filter(Boolean);

    for (const scope of scopes) {
      for (const selector of imageSelectors) {
        const image = scope.querySelector(selector);
        if (image instanceof HTMLImageElement && isVisible(image)) return image;
      }
    }
    return null;
  };

  const readMotionSettings = () => {
    const styles = window.getComputedStyle(document.documentElement);
    const durationValue = styles.getPropertyValue('--ref-cart-fly-duration').trim();
    const parseDuration = (value, fallback) => {
      if (!value) return fallback;
      const amount = Number.parseFloat(value);
      if (!Number.isFinite(amount)) return fallback;
      return value.endsWith('ms') ? amount : value.endsWith('s') ? amount * 1000 : amount;
    };
    return {
      duration: Math.min(900, Math.max(360, parseDuration(durationValue, 590))),
      endScale: Math.min(.4, Math.max(.06, Number.parseFloat(styles.getPropertyValue('--ref-cart-fly-end-scale')) || .12)),
      bounceDuration: Math.min(600, Math.max(180, parseDuration(styles.getPropertyValue('--ref-cart-bounce-duration').trim(), 320)))
    };
  };

  const pulseCart = (cart, bounceDuration) => new Promise((resolve) => {
    cart.classList.remove('ref-cart-fly-pulse');
    void cart.offsetWidth;
    cart.classList.add('ref-cart-fly-pulse');
    window.setTimeout(() => {
      cart.classList.remove('ref-cart-fly-pulse');
      resolve();
    }, bounceDuration + 40);
  });

  const createVisibleCartTarget = (cart) => {
    const proxy = document.createElement('span');
    const icon = cart.querySelector('svg');
    proxy.className = 'ref-cart-fly-target';
    proxy.setAttribute('aria-hidden', 'true');
    if (icon) proxy.appendChild(icon.cloneNode(true));
    document.body.appendChild(proxy);
    void proxy.offsetWidth;
    proxy.classList.add('is-visible');
    return proxy;
  };

  const flyToCart = (image, cart, button) => {
    if (reducedMotion.matches || !image || !cart) return Promise.resolve();

    const imageRect = image.getBoundingClientRect();
    const buttonRect = button?.getBoundingClientRect();
    const imageIsOnscreen = isInViewport(imageRect, 4);
    const imageRatio = imageRect.width > 0 ? imageRect.height / imageRect.width : 1;
    const fallbackWidth = clamp((buttonRect?.width || 320) * .24, 68, 96);
    const fallbackHeight = clamp(fallbackWidth * imageRatio, 68, 112);
    const fallbackLeft = clamp(
      (buttonRect?.left || window.innerWidth / 2) + (buttonRect?.width || 0) / 2 - fallbackWidth / 2,
      12,
      window.innerWidth - fallbackWidth - 12
    );
    const fallbackTop = clamp(
      (buttonRect?.top || window.innerHeight * .62) - fallbackHeight - 14,
      14,
      window.innerHeight - fallbackHeight - 14
    );
    const sourceRect = imageIsOnscreen ? imageRect : {
      top: fallbackTop,
      left: fallbackLeft,
      width: fallbackWidth,
      height: fallbackHeight,
      right: fallbackLeft + fallbackWidth,
      bottom: fallbackTop + fallbackHeight
    };

    const realIcon = cart.querySelector('svg') || cart;
    const realTargetRect = realIcon.getBoundingClientRect();
    const cartIsOnscreen = isInViewport(realTargetRect, 4);
    const visibleCartTarget = cartIsOnscreen ? cart : createVisibleCartTarget(cart);
    const targetIcon = cartIsOnscreen ? realIcon : visibleCartTarget;
    const targetRect = targetIcon.getBoundingClientRect();
    const cleanupTarget = () => {
      if (visibleCartTarget !== cart) visibleCartTarget.remove();
    };
    if (sourceRect.width < 8 || sourceRect.height < 8 || targetRect.width < 4 || targetRect.height < 4) {
      cleanupTarget();
      return Promise.resolve();
    }

    const clone = image.cloneNode(true);
    const imageStyle = window.getComputedStyle(image);
    clone.removeAttribute('id');
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.removeAttribute('loading');
    clone.src = image.currentSrc || image.src;
    clone.alt = '';
    clone.setAttribute('aria-hidden', 'true');
    clone.className = 'ref-cart-fly-clone';
    if (!imageIsOnscreen) clone.classList.add('is-viewport-fallback');
    Object.assign(clone.style, {
      top: `${sourceRect.top}px`,
      left: `${sourceRect.left}px`,
      width: `${sourceRect.width}px`,
      height: `${sourceRect.height}px`,
      objectFit: imageIsOnscreen ? imageStyle.objectFit : 'contain',
      objectPosition: imageStyle.objectPosition,
      borderRadius: imageIsOnscreen ? imageStyle.borderRadius : '16px'
    });
    document.body.appendChild(clone);

    const sourceCenterX = sourceRect.left + sourceRect.width / 2;
    const sourceCenterY = sourceRect.top + sourceRect.height / 2;
    const targetCenterX = targetRect.left + targetRect.width / 2;
    const targetCenterY = targetRect.top + targetRect.height / 2;
    const deltaX = targetCenterX - sourceCenterX;
    const deltaY = targetCenterY - sourceCenterY;
    const arc = Math.min(150, Math.max(54, Math.abs(deltaX) * .08 + Math.abs(deltaY) * .035));
    const { duration, endScale, bounceDuration } = readMotionSettings();

    if (typeof clone.animate !== 'function') {
      clone.remove();
      return pulseCart(visibleCartTarget, bounceDuration).finally(cleanupTarget);
    }

    let animation;
    try {
      animation = clone.animate([
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 1, offset: 0 },
        { transform: `translate3d(${deltaX * .34}px,${deltaY * .23 - arc}px,0) scale(.76)`, opacity: .98, offset: .34 },
        { transform: `translate3d(${deltaX * .76}px,${deltaY * .67 - arc * .48}px,0) scale(.36)`, opacity: .72, offset: .76 },
        { transform: `translate3d(${deltaX}px,${deltaY}px,0) scale(${endScale})`, opacity: 0, offset: 1 }
      ], {
        duration,
        easing: 'cubic-bezier(.2,.78,.22,1)',
        fill: 'forwards'
      });
    } catch (error) {
      clone.remove();
      return pulseCart(visibleCartTarget, bounceDuration).finally(cleanupTarget);
    }

    const finished = animation.finished && typeof animation.finished.then === 'function'
      ? animation.finished.catch(() => undefined)
      : new Promise((resolve) => window.setTimeout(resolve, duration));

    return finished
      .then(async () => {
        clone.remove();
        await pulseCart(visibleCartTarget, bounceDuration);
      })
      .finally(() => {
        clone.remove();
        cleanupTarget();
      });
  };

  const isUsableAddButton = (button) => {
    if (!(button instanceof HTMLElement)) return false;
    return !button.matches(':disabled, [aria-disabled="true"], .shopify-payment-button__button');
  };

  const cartEndpoint = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}${path}`;
  };

  const updateCartCount = (cartLink, cartState) => {
    const count = Number(cartState?.item_count || 0);
    let badge = cartLink.querySelector('.ref-header__cart-count');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'ref-header__cart-count';
      badge.setAttribute('aria-hidden', 'true');
      cartLink.appendChild(badge);
    }
    if (badge) {
      if (count > 0) badge.textContent = count > 99 ? '99+' : String(count);
      else badge.remove();
    }
    cartLink.setAttribute('aria-label', count > 0 ? `Cart, ${count} ${count === 1 ? 'item' : 'items'}` : 'Cart');
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartState } }));
  };

  const clearAddError = (form) => form.querySelector('.ref-cart-add-error')?.remove();

  const showAddError = (form, message) => {
    clearAddError(form);
    const error = document.createElement('p');
    error.className = 'ref-cart-add-error';
    error.setAttribute('role', 'alert');
    error.textContent = message || 'This item could not be added. Please try again.';
    form.appendChild(error);
  };

  const replayNativeSubmit = (form, button) => {
    replayingForms.add(form);
    try {
      if (typeof form.requestSubmit === 'function') {
        const connectedSubmitter = button.isConnected && button.form === form ? button : undefined;
        form.requestSubmit(connectedSubmitter);
      } else {
        form.submit();
      }
    } catch (error) {
      HTMLFormElement.prototype.submit.call(form);
    }
    window.setTimeout(() => replayingForms.delete(form), 1200);
  };

  /* Add through Shopify's Ajax endpoint, confirm the response, then finish inside the cart drawer. */
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(nativeForms) || replayingForms.has(form)) return;
    if (activeForms.has(form)) {
      event.preventDefault();
      return;
    }
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (!isUsableAddButton(button)) return;
    const cart = findCart();
    const image = findProductImage(button, form);
    if (!cart) return;

    event.preventDefault();
    activeForms.add(form);
    clearAddError(form);
    button.setAttribute('aria-busy', 'true');
    const wasDisabled = button.hasAttribute('disabled');
    button.setAttribute('disabled', '');

    try {
      const response = await fetch(cartEndpoint('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        const shopifyError = new Error(result.description || result.message || 'This item could not be added.');
        shopifyError.isShopifyResponse = true;
        throw shopifyError;
      }

      const cartStateRequest = fetch(cartEndpoint('cart.js'), { headers: { Accept: 'application/json' } })
        .then((cartResponse) => cartResponse.ok ? cartResponse.json() : null)
        .then((cartState) => {
          if (cartState) updateCartCount(cart, cartState);
          return cartState;
        })
        .catch(() => null);
      const cartRequest = Promise.race([
        cartStateRequest,
        new Promise((resolve) => window.setTimeout(() => resolve(null), 1500))
      ]);
      const flight = Promise.resolve()
        .then(() => flyToCart(image, cart, button))
        .catch(() => undefined);
      const [cartState] = await Promise.all([cartRequest, flight]);
      const drawer = document.querySelector('[data-cart-drawer]');
      if (cartState && drawer) {
        document.dispatchEvent(new CustomEvent('cart:open', { detail: { cart: cartState, trigger: button } }));
      } else {
        window.location.assign(cart.href || cartEndpoint('cart'));
      }
    } catch (error) {
      if (error?.isShopifyResponse) {
        showAddError(form, error.message);
      } else {
        if (!wasDisabled) button.removeAttribute('disabled');
        replayNativeSubmit(form, button);
      }
    } finally {
      activeForms.delete(form);
      button.removeAttribute('aria-busy');
      if (!wasDisabled) button.removeAttribute('disabled');
    }
  }, true);
})();
/* End 59 product-to-cart flight. */

/* Mobile product purchase bar. It submits the native Shopify product form. */
(() => {
  const sticky = document.querySelector('[data-mobile-buy]');
  const form = document.querySelector('form.product-form');
  const nativeButton = form?.querySelector('button[type="submit"]');
  const stickyButton = sticky?.querySelector('[data-mobile-buy-button]');
  const stickyLabel = sticky?.querySelector('[data-mobile-buy-label]');
  if (!sticky || !form || !nativeButton || !stickyButton || !stickyLabel) return;

  const mobile = window.matchMedia('(max-width: 820px)');
  let nativeButtonVisible = false;

  const syncButton = () => {
    const busy = nativeButton.getAttribute('aria-busy') === 'true';
    stickyButton.disabled = nativeButton.disabled;
    stickyButton.toggleAttribute('aria-busy', busy);
    stickyLabel.textContent = busy ? 'Adding...' : (nativeButton.disabled ? 'Sold out' : 'Add to cart');
  };

  const updateVisibility = () => {
    const shouldShow = mobile.matches && window.scrollY > 48 && !nativeButtonVisible;
    sticky.classList.toggle('is-visible', shouldShow);
    sticky.setAttribute('aria-hidden', String(!shouldShow));
    sticky.toggleAttribute('inert', !shouldShow);
    document.documentElement.classList.toggle('ref-mobile-buy-is-visible', shouldShow);
  };

  const observer = new IntersectionObserver((entries) => {
    nativeButtonVisible = entries[0]?.isIntersecting === true;
    updateVisibility();
  }, { threshold: 0.2 });

  observer.observe(nativeButton);
  new MutationObserver(syncButton).observe(nativeButton, {
    attributes: true,
    attributeFilter: ['disabled', 'aria-busy'],
  });

  stickyButton.addEventListener('click', () => {
    if (nativeButton.disabled) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(nativeButton);
    else nativeButton.click();
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility, { passive: true });
  if (typeof mobile.addEventListener === 'function') mobile.addEventListener('change', updateVisibility);
  else mobile.addListener(updateVisibility);
  syncButton();
  updateVisibility();
})();
/* End mobile product purchase bar. */
